import { render } from "./SettingSidebar.vue?vue&type=template&id=8881f2fe&scoped=true&ts=true"
import script from "./SettingSidebar.vue?vue&type=script&lang=ts"
export * from "./SettingSidebar.vue?vue&type=script&lang=ts"

import "./SettingSidebar.vue?vue&type=style&index=0&id=8881f2fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8881f2fe"]])

export default __exports__